module.exports = __webpack_public_path__ + "img/usuario.01d7a725.svg";